import { RETURN_METHOD_COMPLAINT, RETURN_METHOD_EXCHANGE, RETURN_METHOD_RESALE, RETURN_METHOD_RETURN } from "../constants";

export function getSelectedReturnMethod(selectedProductValue) {
    if (isComplaintSelected(selectedProductValue)) {
        return RETURN_METHOD_COMPLAINT;
    }
    if (isReturnSelected(selectedProductValue)) {
        return RETURN_METHOD_RETURN;
    }
    if (isExchangeSelected(selectedProductValue)) {
        return RETURN_METHOD_EXCHANGE;
    }
    if (isResaleSelected(selectedProductValue)) {
        return RETURN_METHOD_RESALE;
    }

    return null;
}

export function isComplaintSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_COMPLAINT;
}

export function isReturnSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_RETURN;
}

export function isExchangeSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_EXCHANGE;
}

export function isResaleSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_RESALE;
}

export function getSelectedProductProductId(selectedProductValues) {
    return selectedProductValues.productId;
}
